module.exports = __webpack_public_path__ + "img/tu_04.8c90edbc.png";